<template>
  <div class="animated fadeIn">
    <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
    <b-card v-else>
      <template v-slot:header>
        <h5>Disbursement Pending</h5>
      </template>

      <b-row class="mb-3">
        <b-col cols="12" md="6">
          <b-form-group label="Cabang">
            <multiselect
              v-model="filters.cabang"
              :options="optionsCabang"
              :allow-empty="true"
              deselect-label=""
              select-label=""
              label="name"
              track-by="name"
              placeholder="Cabang"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group label="No. Faktur">
            <b-form-input
              v-model="filters.noFaktur"
              type="search"
              placeholder="Masukkan No. Faktur"
              @keyup.enter="onSearch"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group label="Status Proses">
            <b-form-select
              v-model="filters.status"
              :options="statusOptions"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group label="Tanggal">
            <div class="d-flex align-items-center">
              <b-form-input
                v-model="filters.startDate"
                type="date"
                class="flex-fill"
              />
              <span class="mx-2">s/d</span>
              <b-form-input
                v-model="filters.endDate"
                type="date"
                class="flex-fill"
              />
            </div>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-button variant="pgiBtn" class="mr-2" @click="onSearch">
            Search
          </b-button>
          <b-button variant="pgiBtn" @click="onReset">
            Reset
          </b-button>
        </b-col>
      </b-row>

      <div class="detail-data-wrapper">
        <b-table
          bordered
          hover
          show-empty
          responsive
          class="mb-3"
          :busy="isBusy"
          :items="data"
          :fields="fields"
        >
          <template v-slot:table-busy>
            <div class="text-center text-primary py-4">
              <b-spinner class="align-middle" />
              <strong class="ml-2">Memuat data...</strong>
            </div>
          </template>

          <template v-slot:empty>
            Tidak ada data.
          </template>

          <template v-slot:cell(noFakturAndCabang)="row">
            <p class="mb-0 normalText">{{ row.item.noFaktur }}</p>
            <p class="mb-1 smallText text-muted">{{ row.item.cabang || row.item.cabangName }}</p>
          </template>

          <template v-slot:cell(nasabah)="row">
            <p class="mb-0">
              <span class="text-muted">No. Anggota:</span>
              {{ row.item.nasabahNo || '-' }}
            </p>
            <p class="mb-0">
              <span class="text-muted">Nama Anggota:</span>
              {{ row.item.nasabahName || '-' }}
            </p>
            <p class="mb-0">
              <span class="text-muted">Bank:</span>
              {{ row.item.bankName || '-' }}
            </p>
            <p class="mb-0">
              <span class="text-muted">No. Rekening:</span>
              {{ row.item.bankNoRek || '-' }}
            </p>
            <p class="mb-0">
              <span class="text-muted">Nama Rekening:</span>
              {{ row.item.bankRegistrationName || '-' }}
            </p>
          </template>

          <template v-slot:cell(informasiTransaksi)="row">
            <p class="mb-0">
              <span class="text-muted">Tanggal:</span>
              {{ $helper.formatDateAndHour(row.item.createdAt) }}
            </p>
            <p class="mb-0">
              <span class="text-muted">Nominal Penerimaan:</span>
              Rp. {{ formatAmount(row.item.transferAmount) }}
            </p>
            <p class="mb-1">
              <span class="text-muted">Status Proses:</span>
              <span :class="[pendingStatusClass(pendingStatus(row.item)), 'ml-1']">
                {{ pendingStatusLabel(row.item) }}
              </span>
            </p>
            <p class="mb-0">
              <span class="text-muted">Status Disbursement:</span>
              <span :class="[resultStatusClass(disburseStatus(row.item)), 'ml-1']">
                {{ resultStatusLabel(disburseStatus(row.item)) }}
              </span>
            </p>
          </template>

          <template v-slot:cell(action)="row">
            <b-link
              :to="{
                name: 'Detail Disbursement Pending',
                params: { id: row.item.noFaktur },
              }"
            >
              <b-button
                size="sm"
                class="table-button view"
                v-b-tooltip.hover
                title="Detail"
              >
                <i class="fa fa-info"></i>
              </b-button>
            </b-link>
          </template>
        </b-table>

        <div class="pagination-wrapper d-flex align-items-center justify-content-between">
          <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
            <b-form-select v-model="perPage" :options="optionsLimit" @change="onLimitChange" />
            <span class="ml-2">{{ totalViewText }}</span>
          </b-input-group>
          <b-pagination
            v-model="currentPage"
            class="mb-0"
            :total-rows="totalRows"
            :per-page="perPage"
            @input="onPageChange"
          />
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import CONSTANTS from '@/constants'

export default {
  name: 'disbursement-pending',
  data() {
    return {
      initStatus: 0,
      filters: this.defaultFilters(),
      optionsCabang: [],
      isBusy: false,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      optionsLimit: CONSTANTS.OPTIONS_LIMIT_PAGINATION,
      fields: [
        { key: 'noFakturAndCabang', label: 'No. Faktur & Cabang' },
        { key: 'nasabah', label: 'Nasabah', thClass: 'min-width-200' },
        { key: 'informasiTransaksi', label: 'Informasi Transaksi', thClass: 'min-width-200' },
        { key: 'action', label: 'Aksi', thClass: 'text-center', tdClass: 'text-center' },
      ],
      data: [],
    }
  },
  computed: {
    PENDING_STATUS() {
      return CONSTANTS.GADAI.STATUS_DISBURSEMENT_PENDING
    },
    DISBURSE_STATUS() {
      return CONSTANTS.GADAI.STATUS_DISBURSEMENT_GADAI
    },
    statusOptions() {
      return [
        { value: null, text: 'Semua Status' },
        { value: this.PENDING_STATUS.PENDING, text: 'PENDING' },
        { value: this.PENDING_STATUS.WAITING_BANK_RESPONSE, text: 'MENUNGGU RESPONS BANK' },
        { value: this.PENDING_STATUS.PROCESS_SHORTFALL, text: 'PROSES KEKURANGAN' },
        { value: this.PENDING_STATUS.PROCESS_REFUND, text: 'PROSES PENGEMBALIAN' },
        { value: this.PENDING_STATUS.COMPLETED, text: 'SELESAI' },
      ]
    },
    totalViewText() {
      const total = this.totalRows
      if (!total) return 'Menampilkan 0 entri'

      const start = (this.currentPage - 1) * this.perPage + 1
      const end = Math.min(start + this.data.length - 1, total)
      return `Menampilkan ${start} - ${end} dari ${total} entri`
    },
  },
  methods: {
    async init() {
      this.initStatus = 0

      try {
        this.initCabang()
        await this.getItems()
        this.initStatus = 1
      } catch (error) {
        this.$helper.parseError(this, error)
        this.initStatus = -1
      }
    },
    defaultFilters() {
      return {
        cabang: null,
        noFaktur: '',
        status: CONSTANTS.GADAI.STATUS_DISBURSEMENT_PENDING.PENDING,
        startDate: null,
        endDate: null,
      }
    },
    initCabang() {
      const cabang = JSON.parse(localStorage.getItem('cabang') || '[]')
      const mappingName = cabang.map(item => ({
        ...item,
        name: item.name.replace(/^\(\d+\)\s*/, ''),
      }))

      this.optionsCabang = [
        { id: null, name: 'Semua Cabang' },
        ...mappingName,
      ]
    },
    getItems(page = 1) {
      this.isBusy = true
      this.data = []
      this.currentPage = isNaN(page) ? 1 : page

      const params = {
        page: this.currentPage - 1,
        size: this.perPage,
      }

      if (this.filters.cabang && this.filters.cabang.id) params.cabangId = this.filters.cabang.id
      if (this.filters.noFaktur) params.noFaktur = this.filters.noFaktur
      if (this.filters.status !== null) params.status = this.filters.status
      if (this.filters.startDate) params.startDate = this.filters.startDate
      if (this.filters.endDate) params.endDate = this.filters.endDate

      return this.$axios.get('gadai-disburse/pending', { params })
        .then(response => {
          this.data = response.data.content || []
          this.totalRows = response.data.totalElements || 0
        })
        .catch(error => {
          if (this.initStatus !== 1) throw error
          this.$helper.parseError(this, error)
        })
        .finally(() => {
          this.isBusy = false
        })
    },
    onSearch() {
      if (this.$helper.isInvalidDateRange(this.filters.startDate, this.filters.endDate)) {
        this.$helper.toastErr(this, 'Tanggal mulai tidak boleh lebih dari tanggal akhir')
        return
      }

      this.getItems(1)
    },
    onReset() {
      this.filters = this.defaultFilters()
      this.getItems(1)
    },
    onLimitChange(value) {
      this.perPage = value
      this.getItems(1)
    },
    onPageChange(page) {
      this.getItems(page)
    },
    formatAmount(value) {
      return this.$helper.addThousandSeparator(value || 0)
    },
    pendingStatus(item) {
      return item.gadaiDisbursePendingStatus !== null && item.gadaiDisbursePendingStatus !== undefined
        ? item.gadaiDisbursePendingStatus
        : this.PENDING_STATUS.PENDING
    },
    disburseStatus(item) {
      return item.gadaiDisburseStatus !== null && item.gadaiDisburseStatus !== undefined
        ? item.gadaiDisburseStatus
        : this.DISBURSE_STATUS.DANA_DITANGGUHKAN
    },
    pendingStatusLabel(item) {
      const status = this.pendingStatus(item)

      if (status === this.PENDING_STATUS.COMPLETED) {
        if (this.disburseStatus(item) === this.DISBURSE_STATUS.DANA_DITANGGUHKAN_GAGAL) {
          return this.hasTransferDocument(item)
            ? 'Selesai Dengan Kekurangan'
            : 'Selesai Tanpa Kekurangan'
        }

        return 'Selesai'
      }

      const labels = {
        [this.PENDING_STATUS.PENDING]: 'Pending',
        [this.PENDING_STATUS.WAITING_BANK_RESPONSE]: 'Menunggu Respons Bank',
        [this.PENDING_STATUS.PROCESS_SHORTFALL]: 'Proses Kekurangan',
        [this.PENDING_STATUS.PROCESS_REFUND]: 'Proses Pengembalian',
        [this.PENDING_STATUS.FAILED]: 'Gagal',
      }
      return labels[status] || '-'
    },
    hasTransferDocument(item) {
      return this.parseDocumentUrls(item.pathFotoTransfer).length > 0
    },
    parseDocumentUrls(value) {
      if (!value) return []
      if (Array.isArray(value)) return value.filter(Boolean)
      return String(value).split(',').map(url => url.trim()).filter(Boolean)
    },
    pendingStatusClass(status) {
      if (status === this.PENDING_STATUS.COMPLETED) return 'status-box status-box-success'
      if (status === this.PENDING_STATUS.PROCESS_REFUND) return 'status-box status-box-secondary'
      if (status === this.PENDING_STATUS.PROCESS_SHORTFALL) return 'status-box status-box-danger'
      if (status === this.PENDING_STATUS.FAILED) return 'status-box status-box-danger'
      if (status === this.PENDING_STATUS.WAITING_BANK_RESPONSE) return 'status-box status-box-primary'
      return 'status-box status-box-warning'
    },
    resultStatusLabel(status) {
      const statusDisburse = this.DISBURSE_STATUS
      const labels = {
        [statusDisburse.WAIT_APPROVAL]: 'Menunggu Persetujuan',
        [statusDisburse.APPROVED_ALL]: 'Persetujuan Lengkap',
        [statusDisburse.DISBURSED]: 'Berhasil Cair',
        [statusDisburse.DANA_DITANGGUHKAN]: 'Dana Ditangguhkan',
        [statusDisburse.DANA_DITANGGUHKAN_GAGAL]: 'Gagal Cair',
        [statusDisburse.CEK_IT]: 'Mohon Hubungi IT',
        [statusDisburse.CANCELLED]: 'Dibatalkan',
        [statusDisburse.REJECTED]: 'Ditolak',
      }
      return labels[status] || '-'
    },
    resultStatusClass(status) {
      const statusDisburse = this.DISBURSE_STATUS
      if (status === statusDisburse.WAIT_APPROVAL) return 'status-box status-box-wait'
      if (status === statusDisburse.APPROVED_ALL) return 'status-box status-box-approved'
      if (status === statusDisburse.DISBURSED) return 'status-box status-box-disbursed'
      if (status === statusDisburse.DANA_DITANGGUHKAN) return 'status-box status-box-warning'
      if (status === statusDisburse.DANA_DITANGGUHKAN_GAGAL) return 'status-box status-box-danger'
      if (status === statusDisburse.CEK_IT) return 'status-box status-box-danger'
      if (status === statusDisburse.CANCELLED) return 'status-box status-box-cancelled'
      if (status === statusDisburse.REJECTED) return 'status-box status-box-rejected'
      return 'status-box status-box-default'
    },
  },
  created() {
    this.init()
  },
}
</script>
